import React, { Component } from 'react'

import * as utils from "../../utils";

import { DeletePollLink } from "./delete-poll";
import { EditPollLink } from "./edit-poll";
import TimeSince from "../../common/components/time-since";
import UserAvatar from "../../avatars/components";
import UserProfileLink from "../../common/components/user-profile-link";

function PollHeader(props) {
  const { question, created, creator } = props.poll;
  const pollId = props.poll.id;
  const { id, first_name, last_name } = creator;
  const isHost = utils.isHost();
  return (
    <div>
      <UserAvatar
        userId={ id }
        firstName={ first_name }
        lastName={ last_name }
        size="small"
      />
      <UserProfileLink
        userId={ id }
        firstName={ first_name }
        lastName={ last_name }
      />
      <TimeSince timestamp={ created } />
      <h4><span>Poll:</span> { question } { isHost &&
          <EditPollLink pollId={ pollId } />
      }
      </h4>
      { isHost &&
        <DeletePollLink pollId={ pollId } />
      }
    </div>
  )
}

export default PollHeader;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/components/poll-header.es6